import React from "react";
import {FormattedMessage} from "react-intl";

// Integration / technology partners, split into two rows scrolling in opposite
// directions (shadcn-style double-row marquee). Logo files are placeholders in
// public/logos/ — drop the real assets in with the same names.
const partnerRowOne = [
    {src: "/logos/logo_xentral.png", alt: "SepaHeld Partner Xentral Logo", width: 130},
    {src: "/logos/logo_moco.svg", alt: "SepaHeld Partner MOCO Agentursoftware Logo", width: 110},
    {src: "/logos/logo_lexware_office.png", alt: "SepaHeld Partner Lexware Office Logo", width: 140},
    {src: "/logos/logo_sevdesk.png", alt: "SepaHeld Partner sevdesk Logo", width: 130},
];

const partnerRowTwo = [
    {src: "/logos/logo_papierkram.svg", alt: "SepaHeld Partner Papierkram Logo", width: 170},
    {src: "/logos/logo_invoiz.png", alt: "SepaHeld Partner invoiz Logo", width: 100},
    {src: "/logos/logo_meinbuero.png", alt: "SepaHeld Partner WISO MeinBüro Logo", width: 180},
    {src: "/logos/logo_gocardless.png", alt: "SepaHeld Partner GoCardless Logo", width: 140},
];

const LogoCard = ({logo}) => (
    <div
        className="flex shrink-0 items-center justify-center rounded-xl bg-white px-8 py-5 shadow-sm ring-1 ring-slate-100">
        <img
            src={logo.src}
            alt={logo.alt}
            loading="lazy"
            style={{width: logo.width}}
            className="h-6 w-auto object-contain"
        />
    </div>
);

const MarqueeRow = ({logos, reverse = false, duration = "45s"}) => {
    // Duplicate the list so the translate -100% loop is seamless.
    const items = [...logos, ...logos];
    return (
        <div className="w-full overflow-hidden">
            <div
                className="group flex gap-6 p-3"
                style={{"--marquee-duration": duration, "--marquee-gap": "1.5rem"}}
            >
                {[0, 1].map((copyIdx) => (
                    <div
                        key={copyIdx}
                        aria-hidden={copyIdx === 1 ? "true" : undefined}
                        className={
                            "flex shrink-0 items-center justify-around gap-6 motion-safe:group-hover:[animation-play-state:paused] " +
                            (reverse ? "motion-safe:animate-marquee-reverse" : "motion-safe:animate-marquee")
                        }
                    >
                        {items.map((logo, i) => (
                            <LogoCard key={`${copyIdx}-${i}-${logo.src}`} logo={logo}/>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

const PartnerLogosMarquee = () => (
    <section className="max-w-4xl mx-auto">
        <div className="text-center mb-10 sm:mb-14 lg:mb-16 space-y-3">
                    <span
                        className="inline-flex items-center justify-center px-3 py-0.5 rounded-full border border-base-content/20 text-sm font-normal text-base-content/80">
                        Integrationen
                    </span>
            <h2 className="font-serif font-extrabold text-2xl md:text-3xl lg:text-4xl tracking-tight">
                Verbindet die Tools, denen du vertraust
            </h2>
            <p className="text-base lg:text-lg text-base-content/70">
                SepaHeld spielt zusammen mit deiner Buchhaltung, deinem ERP und deinem Zahlungspartner.
            </p>
        </div>
        <div className="relative">
            <div
                className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-slate-50 to-transparent sm:w-24"/>
            <div
                className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-slate-50 to-transparent sm:w-24"/>
            <MarqueeRow logos={partnerRowOne} duration="45s"/>
            <MarqueeRow logos={partnerRowTwo} reverse duration="50s"/>
        </div>
    </section>
);

export default PartnerLogosMarquee;
